export default __webpack_public_path__ + "static/media/next_img.75d1de64.svg";